import {AuthServerType} from "./auth-server-type";

export const ORGANIZER_ROLE: string = "ROLE_ORGANISER";
export const ADMINISTRATOR_ROLE: string = "ROLE_ADMINISTRATOR";
export const ORGANISERS_ADMINISTRATOR_ROLE: string = "ROLE_ORGANISERS_ADMINISTRATOR";
export const DIGI_ROLE: string = "ROLE_DIGI";
export const HELPER_ROLE: string = "ROLE_HELPER";
export const USER_ROLE: string = "ROLE_USER";

export const ADMINISTRATOR_ROLE_ID: number = 1;
export const ORGANIZER_ROLE_ID: number = 2;
export const HELPER_ROLE_ID: number = 3;
export const USER_ROLE_ID: number = 4;

export const ORGANISERS_ADMINISTRATOR_ROLE_ID: number = 5;

export function getRoleIdForRole(role?:string):number | undefined {
  switch (role) {
    case ORGANIZER_ROLE:
      return ORGANIZER_ROLE_ID;
    case ADMINISTRATOR_ROLE:
      return ADMINISTRATOR_ROLE_ID;
    case USER_ROLE:
      return USER_ROLE_ID;
    case HELPER_ROLE:
      return HELPER_ROLE_ID;
    case ORGANISERS_ADMINISTRATOR_ROLE:
      return ORGANISERS_ADMINISTRATOR_ROLE_ID;
    default:
      return undefined;
  }
}
export interface JwtResponse {
  token?: string;
  refreshToken?: string;
  type?: string;
  id?: number;
  username?: string;
  email?: string;
  roles?: Array<string>;
  authServerType: AuthServerType;
}
